module.exports = __webpack_public_path__ + "static/media/vin-model-logo.a8b3cf2f.svg";